<template>
    <span v-if="name" class="tile-badge badge-border-radius-16 px-2 py-1" :class="[name]" style="opacity: 1;">
        {{ name }}
    </span>
</template>



<script lang="ts">

import { BADGE_TYPES } from '@/constants/BadgeTypes';

export default {
    name: "TileBadge",
    props: {
        name: {
            type: String as () => BADGE_TYPES,
        },
    }
};
</script>



<style scoped lang="scss">

.tile-badge {
    position: absolute;
    top: 0px;
    left: 0px;
    opacity: 100%;
    background: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'default');
    font-weight: 600;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    z-index: 2;
    color: vars.get-map-value(vars.$tile, 'badge', 'text-color');
}

.Social {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'social');
}

.Verify {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'verify');
}

.Tutorials {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'tutorials');
}

.Promos {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'promos');
}

.Surveys {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'surveys');
}

.Apps {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'apps');
}

.Games {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'games');
}

.Videos {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'videos');
}

.Offers {
    background-color: vars.get-map-value(vars.$tile, 'badge', 'background-color', 'offers');
}
</style>
